function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 40C8.954 40 0 31.046 0 20S8.954 0 20 0s20 8.954 20 20-8.954 20-20 20z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.156 28.132l6.575-6.563 6.482 6.525a1.239 1.239 0 001.764 0 1.266 1.266 0 000-1.779L21.504 19.8l6.625-6.614a1.253 1.253 0 000-1.78 1.268 1.268 0 00-1.786 0l-6.616 6.605-6.597-6.642a1.241 1.241 0 00-1.764 0 1.266 1.266 0 000 1.78l6.588 6.633-6.583 6.573a1.253 1.253 0 000 1.779c.492.49 1.291.49 1.785-.001z",
  fill: "#FFF",
  fillRule: "nonzero"
}));

function SvgRemove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgRemove;